import _uniqBy from 'lodash/uniqBy.js';

const state = {
    holidays_from: null,
    holidays_to: null,
    holidays: [],
    country_holidays: [],
};

const mutations = {
    SET_HOLIDAYS(state, {from, to, holidays}) {
        // update loaded holiday range
        if ( !state.holidays_from || from < state.holidays_from ) {
            state.holidays_from = from;
        }
        if ( !state.holidays_to || to > state.holidays_to ) {
            state.holidays_to = to;
        }

        state.holidays = _uniqBy([...state.holidays, ...holidays], 'holiday_id');
    },

    SET_COUNTRY_HOLIDAYS(state, country_holidays) {
        state.country_holidays = country_holidays;
    },
};

import * as getters from './getters';
import * as actions from './actions';

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
